
export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<></>
	);
};

export const GraphicCueContent = ({
	cue,
}) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        `}
		>
			<span className="font-semibold">
				Q&A • Current question
			</span>
		</div>
	);
};
